import React, { createContext, useContext, useMemo } from 'react'
import { useFlags, useFlagsStatus } from '@unleash/proxy-client-react'

const UnleashFlagsContext = createContext({
  flagsReady: false,
  isEnabled: () => false,
})

export const UnleashProvider = ({ children }) => {
  const flags = useFlags()
  const { flagsReady } = useFlagsStatus()

  const flagsMap = useMemo(
    () => Object.fromEntries(flags.map(f => [f.name, f.enabled || false])),
    [flags]
  )

  const value = useMemo(
    () => ({
      flagsReady,
      isEnabled: flagName => flagsMap[flagName] || false,
    }),
    [flagsMap, flagsReady]
  )

  return (
    <UnleashFlagsContext.Provider value={value}>
      {children}
    </UnleashFlagsContext.Provider>
  )
}

export const useUnleashFlag = flagName =>
  useContext(UnleashFlagsContext).isEnabled(flagName)

export const useUnleashStatus = () => useContext(UnleashFlagsContext).flagsReady

export const useUnleashFeatureValue = () =>
  useContext(UnleashFlagsContext).isEnabled
